/* eslint-disable */
import { useMemo } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-chartjs-2 components
import { Bar } from "react-chartjs-2";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SuiButton from "components/SuiButton";
// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Typography from "@mui/material/Typography";
import Icon from "@mui/material/Icon";

// VerticalBarChart configurations
import configs from "examples/Charts/BarCharts/VerticalBarChart/configs";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";
import { Divider } from "@mui/material";

import Watermark from "@uiw/react-watermark";
import downloadjs from "downloadjs";
import html2canvas from "html2canvas";

const handleCaptureClick = async () => {
  const canvas = await html2canvas(document.getElementById("stackW"));
  const dataURL = canvas.toDataURL("image/png");
  downloadjs(dataURL, "documents_topic_chart.png", "image/png");
};

function VerticalBarChart({ title, description, height, chart }) {
  const chartDatasets = chart.datasets.map((dataset) => ({
    ...dataset,
    weight: 5,
    borderWidth: 0,
    borderRadius: 4,
    backgroundColor: colors[dataset.color].main,
    fill: false,
    maxBarThickness: 50,
  }));

  const { data, options } = configs(chart.labels, chartDatasets);

  const renderChart = (
    <SuiBox p={2}>
      {title || description ? (
        <SuiBox px={description ? 1 : 0} pt={description ? 1 : 0}>
          {title && (
            <SuiBox mb={1}>
              <SuiTypography variant="h6">
                {title} {"      "}
                <SuiButton variant="button" buttonColor="dark" onClick={handleCaptureClick}>
                  PNG&nbsp;
                  <Icon className="">download</Icon>
                </SuiButton>
              </SuiTypography>
            </SuiBox>
          )}
          <SuiBox mb={2}>
            <SuiTypography variant="button" fontWeight="regular" textColor="text">
              {description}
            </SuiTypography>
          </SuiBox>
        </SuiBox>
      ) : null}
      {useMemo(
        () => (
          <div id="stackW">
            <Watermark content="MySLR ©">
              <SuiBox height={height}>
                <Bar data={data} options={options} />
              </SuiBox>
            </Watermark>
          </div>
        ),
        [chart, height]
      )}
      <Divider />

      <Grid container spacing={2}>
        <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
          <SuiBox
            sx={{
              mr: 1,
              border: "12px solid #17c1e8",
            }}
            display="inline-block"
          />
        </Grid>
        <Grid item xs={11}>
          <Typography style={{ fontSize: 12, fontStyle: "normal", lineHeight: 1.2 }}>
            The number of documents for each topic by assigning the document to the topic that has
            the most weight in that document.
          </Typography>
        </Grid>
        <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
          <SuiBox
            sx={{
              mr: 1,
              border: "12px solid #ea0606",
            }}
            display="inline-block"
          />
        </Grid>
        <Grid item xs={11}>
          <Typography style={{ fontSize: 12, fontStyle: "normal", lineHeight: 1.2 }}>
            The number of documents for each topic by summing up the actual weight contribution of
            each topic to respective documents.
          </Typography>
        </Grid>
      </Grid>
    </SuiBox>
  );

  return title || description ? <Card>{renderChart}</Card> : renderChart;
}

// Setting default values for the props of VerticalBarChart
VerticalBarChart.defaultProps = {
  title: "",
  description: "",
  height: "19.125rem",
};

// Typechecking props for the VerticalBarChart
VerticalBarChart.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  chart: PropTypes.objectOf(PropTypes.array).isRequired,
};

export default VerticalBarChart;
